<div [ngClass]="this.srvRpDesign.getResponsiveClass('p-3', 'px-2 py-3')">
  <app-search-filter-form (callback)="callback($event)" ></app-search-filter-form>
</div>
